var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5584 0.0843938C15.3206 -0.0281313 15.0488 0.00937709 14.845 0.196919L11.6178 6.75151L8.39066 0.196919C8.15287 -0.0656397 7.74522 -0.0656397 7.50743 0.196919L4.31423 6.75151L1.12102 0.196919C0.917197 0.00937709 0.645435 -0.0281313 0.407643 0.0843938C0.169851 0.196919 0 0.459478 0 0.759545V13.2498C0 13.6624 0.305732 14 0.679406 14H15.3206C15.6943 14 16 13.6624 16 13.2498V0.759545C15.966 0.459478 15.7962 0.196919 15.5584 0.0843938Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrown);
export default __webpack_public_path__ + "static/media/icon-crown.08fe1b0fa86c310933824025838ad527.svg";
export { ForwardRef as ReactComponent };